// extracted by mini-css-extract-plugin
export default {"rating":"dK-z","numberOfStars":"eK-z","count":"fK-z","barGraphSpacing":"gK-z","barGraph":"hK-z"};